import newsTicker from '../../../../../../src24/js/modules/newsTicker';

window.addEventListener('load', () => {
    newsTicker.init();
});
